import { render, staticRenderFns } from "./ResultsListDisplayOptions.vue?vue&type=template&id=07d3a4a5"
import script from "./ResultsListDisplayOptions.vue?vue&type=script&lang=js"
export * from "./ResultsListDisplayOptions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports